const removeEmpty = (obj: any) => {
  const newObj = obj;
  Object.keys(newObj).forEach((key) => {
    if (newObj[`${key}`] === undefined || newObj[`${key}`] === null) {
      delete newObj[`${key}`];
    }
  });

  return newObj;
};

const removeEmptyWithEmptyStr = (obj: any) => {
  const newObj = obj;
  Object.keys(newObj).forEach((key) => {
    if (newObj[`${key}`] === undefined || newObj[`${key}`] === '') {
      delete newObj[`${key}`];
    }
  });

  return newObj;
};

export { removeEmpty, removeEmptyWithEmptyStr };
